import { Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { Box, Character, Lesson, Privilege, PrivilegeSettings } from '@df/interfaces';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LESSON_COMPLETED } from '@app/app.constants';
import { PrivilegeService } from '@app/core/services/privilege.service';

@Component({
    selector: 'app-prepare-privileges',
    templateUrl: './prepare-privileges.component.html',
    styleUrls: ['./prepare-privileges.component.scss']
})
export class PreparePrivilegesComponent implements OnChanges, OnDestroy {
    @Input() boxes: Box[] = [];
    @Input() privilege_settings: PrivilegeSettings[] = [];
    @Input() characters: Character[] = [];
    @Input() privileges: Privilege[] = [];
    @Input() lesson: Lesson;
    lesson_completed = LESSON_COMPLETED;
    public privilegesForm: FormGroup;

    errorMessage: string;
    message: string;

    constructor(private formBuilder: FormBuilder, private privSvc: PrivilegeService) {
        this.privilegesForm = this.formBuilder.group({
            privilegesData: this.formBuilder.array([this.initPrivilegeDataForm()])
        });
    }

    get privilegesData() {
        return this.privilegesForm.get('privilegesData') as FormArray;
    }

    public ngOnDestroy(): void {}

    get formData() {
        return <FormArray>this.privilegesForm.get('privilegesData');
    }

    public ngOnChanges(): void {
        if (this.lesson) {
            for (const priv_form of (<FormArray>this.privilegesForm.controls['privilegesData']).controls) {
                (<FormGroup>priv_form).controls['lesson'].setValue(this.lesson.id, { onlySelf: true });
            }
            this.privilegesForm.controls['privilegesData'].updateValueAndValidity({ onlySelf: true });
        }
        if (this.privilege_settings && this.privilege_settings.length > 0) {
            this.removePrivilgeSettings(0);
            for (const setting of this.privilege_settings) {
                const form = this.formBuilder.group({
                    lesson: [setting.lesson, Validators.required],
                    character: [setting.character, Validators.required],
                    privilege: [setting.privilege, Validators.required],
                    boxes: [setting.boxes, Validators.required]
                });
                (<FormArray>this.privilegesForm.controls['privilegesData']).push(form);
            }
        }
    }

    initPrivilegeDataForm(lesson_id = null) {
        return this.formBuilder.group({
            lesson: [lesson_id ? lesson_id : '', Validators.required],
            character: ['', Validators.required],
            privilege: ['', Validators.required],
            box: ['', Validators.required]
        });
    }

    public onSubmit(): void {
        if (this.lesson) {
            this.privSvc.deletePrivilegeSettingsForLesson(this.lesson.id).subscribe(() => {
                const priv_data = this.privilegesForm.controls['privilegesData'].value;
                this.privSvc.createPrivilegeSettings(priv_data).subscribe(() => {
                    this.message = 'Настройки привилегий сохранены';
                });
            });
        } else {
            this.errorMessage = 'Не создан урок';
        }
    }

    public addPrivilegeSettings(): void {
        this.message = null;
        const form = this.initPrivilegeDataForm(this.lesson.id);
        (<FormArray>this.privilegesForm.controls['privilegesData']).push(form);
    }

    public removePrivilgeSettings(i: number): void {
        this.message = null;
        (<FormArray>this.privilegesForm.controls['privilegesData']).removeAt(i);
    }
}
